import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import cozajistime from "./cozajistime.webp";
import { fontText, fontTitle } from '../MainPage/styles';

export default function CoZajistime() {
    const col = useMediaQuery(`(max-width:1200px)`);

    return (
        <Grid container spacing={{ xs: 2, md: 6, lg: 12, xl: 28 }} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            sx={{ py: '120px', textAlign: 'left', scrollMarginTop: '0px', alignItems: 'flex-start', ...(col && { flexDirection: 'column-reverse' }) }}
            id='cozajistime'>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }} sx={{ display: 'flex', justifyContent: { xs: 'normal', sm: 'normal', md: 'flex-end', lg: 'normal' } }}>
                <Box component={'img'} src={cozajistime} sx={{
                    width: '100%', maxWidth: { xs: '100%', sm: '100%', md: '500px', lg: '100%' }, height: 'auto', display: 'block',
                    pt: { xs: '50px', sm: '30px', md: '30px', lg: '0px' }
                }} />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <Typography sx={{ ...fontTitle, pb: '16px' }}>
                    Co pro vás zajistíme?
                </Typography>
                <Typography sx={{ ...fontText }} component={'ul'}>
                    <li style={{ marginTop: '16px' }}>
                        <b>Hloubkové čištění u vás doma:</b> Specializujeme se na precizní tepování sedacích souprav, křesel a kobercůpřímo u vás. Vše vyřešíme na místě, bez nutnosti cokoliv někam odvážet.
                    </li>
                    <li style={{ marginTop: '16px' }}>
                        <b>Odstranění odolných skvrn a nehod:</b> Pomocí speciální chemie a silných extraktorů zlikvidujeme i těžké fleky od nápojů, jako je rozlitá káva, červené víno nebo sladké limonády.
                    </li>
                    <li style={{ marginTop: '16px' }}>
                        <b>Likvidace zašlé špíny z běžného provozu:</b> Zbavíme váš nábytek nevzhledných tmavých a umaštěných map, které na sedačkách a opěrkách vznikají každodenním sezením.
                    </li>
                    <li style={{ marginTop: '16px' }}>
                        <b>Záchrana zašlapaných koberců:</b> Silným podtlakem vytáhneme z kobercových vláken hluboko usazený prach, špínu a nánosy z bot, čímž koberci vrátíme jeho původní barvu a nadýchanost.
                    </li>
                </Typography>
            </Grid>
        </Grid>
    )
} 